import { createContext, useContext } from 'react';

import type { SrfUserEntry } from '../lib/srf-user-entry';

/**
 * What the requester of the service request being accepted typed in, for the cards of the form to
 * show next to their own fields. Outside a provider the cards show nothing.
 */
export const SrfUserEntryContext = createContext<SrfUserEntry | undefined>(undefined);

export const useSrfUserEntry = () => useContext(SrfUserEntryContext);
